<template>
  <div id="position">
    <div class="page-header header-filter" data-parallax="true" style="background-image: url('/static/img/contact.jpg'); height:50vh; background-position:0px 44%">
        <div class="container">
            <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
                <div class="brand text-center">
                <h1 class="title">交通位置</h1>
                <h3 class="title description">Location</h3>
                </div>
            </div>
            </div>

        </div>
        </div>
        <div class="main main-raised">
            <div class="container">
              <div class="section">
                  <div class="row">
                    <div class="col-md-5 col-12">
                      <div class="googlemap-container">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1075.4043552994037!2d121.24578605398234!3d24.958809944059926!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346823eb346dabc3%3A0xc852ff28ffbabdea!2z5Lit5Y6f5aSn5a2455-l6KGM6aCY6Iiq6aSo!5e0!3m2!1szh-TW!2stw!4v1568864724126!5m2!1szh-TW!2stw" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
                      </div>
                    </div>
                    <div class="col-md-7 col-12">
                      <div class="info info-horizontal" style="padding:0px 0px 0px">
                        <div class="icon icon-primary">
                          <i class="material-icons">pin_drop</i>
                        </div>
                        <div class="description">
                          <h4 class="info-title">Address</h4>
                          <p>
                            320 桃園市中壢區新中北路499號
                          </p>
                          <p> No. 499, Xinzhong N. Rd., Zhongli Dist.,
                            <br> Taoyuan City 320,
                            <br> Taiwan (R.O.C.)
                          </p>
                        </div>
                      </div>
                      <div class="info info-horizontal" style="padding:0px 0px 0px">
                        <div class="icon icon-primary">
                          <i class="material-icons">directions_car</i>
                        </div>
                        <div class="description">
                          <h4 class="info-title">How to go</h4>
                          <p>
                            <span class="font-weight-bold">■ 汽車 Car</span><br>
                            行經國道1號自內壢出口下交流道<br>
                            行經中園路 > 中華路 > 普忠路 > <br>
                            新中北路 > 中原大學知行領航館<br><br>
                            
                            <span class="font-weight-bold">■ 高鐵 High Speed Rail</span><br>
                            搭乘桃園客運高鐵快捷公車至新生路站<br>
                            於新生路轉乘1號公車至中原站<br>
                            步行至中原大學知行領行館
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "position",
  props: [],
  data() {
    return {
      
    };
  },
  methods: {},
  filters: {},
  computed: {},
  created() {},
  mounted() {
  },
  components: {},
  watch: {}
};

  </script>
<style scoped>
.googlemap-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

.googlemap-container iframe,
.googlemap-container object,
.googlemap-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/contact/position.vue